"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getRestrictedDate = exports.MIN_DATE = exports.MAX_DATE = void 0;
/**
 * @copyright
 * Copyright (c) 2024 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */

var MAX_DATE = exports.MAX_DATE = "9999-12-31";
var MIN_DATE = exports.MIN_DATE = "1900-01-01";
var getRestrictedDate = exports.getRestrictedDate = function getRestrictedDate(type, maxDate, minDate) {
  if (type !== "date") {
    return {
      max: maxDate,
      min: minDate
    };
  }
  var max = maxDate || MAX_DATE;
  var min = minDate || MIN_DATE;
  return {
    max: max,
    min: min
  };
};